import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SAASBRANDNAME } from 'src/assets/data/enum/saasBrandName.enum';
import { ThemeConfig } from 'src/assets/data/enum/themeConfig';
import { Supplier } from '../_models/supplier';
import { environment } from '../../../environments/environment';

@Injectable()
export class SupplierService {
  private apiBaseUrl = environment.apiBaseUrl;
  list = [];

  constructor(private http: HttpClient) {}

  getSuppliers(): Observable<Supplier[]> {
    const xSaas = ThemeConfig.brand || SAASBRANDNAME.XFARM;

    // Set the SaaS brand to receive the correct products from the backend
    const headers = new HttpHeaders({ 'x-saas': xSaas.toLocaleLowerCase() });

    return this.http.get<any>(this.apiBaseUrl + 'api/private/v2/suppliers', { headers }).pipe(
      map((response) => {
        this.list = response;
        return response;
      })
    );
  }

  getSupplier(id: number): Observable<Supplier> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v2/suppliers/' + id)
      .pipe(map((response) => response));
  }

  saveSupplier(supplierItem): Observable<Supplier> {
    const supplier = { ...supplierItem };
    delete supplier.lastUpdated;
    delete supplier.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    supplier.companyId = companySelected ? companySelected.id : null;

    if (supplier.user != null && supplier.user.id != null) {
      supplier.user = { id: supplier.user.id };
    }
    if (supplier.id) {
      return this.http
        .put<Supplier>(this.apiBaseUrl + 'api/private/v2/suppliers/' + supplier.id, supplier)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Supplier>(this.apiBaseUrl + 'api/private/v2/suppliers/', supplier)
        .pipe(map((response) => response));
    }
  }

  deleteSupplier(id: number): Observable<Supplier> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/suppliers/' + id).pipe(
      map(() => {
        return { id } as Supplier;
      })
    );
  }

  getLocalSupplierById = (id: number): Supplier => {
    let supplier: Supplier;
    for (const item of this.list) {
      if (item.id === id) {
        supplier = item;
        break;
      }
    }
    return supplier;
  };
}
